export default __webpack_public_path__ + "static/media/ahmed.dd82a1dc.jpg";